/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './muteConvo.defs'
export { main as default } from './muteConvo.defs'
